import { cn } from "@becon-team/becon-fe-lib/my-tailwind-css";
import { useTranslation } from "react-i18next";

import type { PropsWithClassName } from "@becon-team/becon-fe-lib/my-types";
import { RoundDownSolidOutline } from "@becon-team/becon-fe-lib/my-svgs";

export interface AccordionBtnProps {
  title: string;
  isOpened: boolean;
  handleClose: () => void;
  handleOpen: () => void;
}

export const AccordionBtn = ({
  className,
  title,
  isOpened,
  handleClose,
  handleOpen,
}: PropsWithClassName<AccordionBtnProps>) => {
  const { t } = useTranslation();

  return (
    <button
      className={cn("my-btn-weak", className)}
      type="button"
      onClick={() => {
        isOpened ? handleClose() : handleOpen();
      }}
    >
      <div className="flex items-center justify-center gap-sp-4">
        {isOpened ? t("{{title}} 닫기", { title }) : t("{{title}} 보기", { title })}
        <RoundDownSolidOutline className={cn("transition-transform", { "-rotate-180": isOpened })} />
      </div>
    </button>
  );
};
